const enumHttpStatusCode = Object.freeze({
  Ok :200,
  NoContent :204,
  MovedPermanently :301,
  BadRequest :400,
  Unauthorized :401,
  Forbidden :403,
  NotFound :404,
  ImATeapot :418,
  InternalServerError :500,
  NotImplemented :501,
  BadGateway :502,
  ServiceUnavailable :503,
  GatewayTimeout :504
  })

export { enumHttpStatusCode }



// WEBPACK FOOTER //
// ./src/enums/HttpStatusCode.js